module.exports = __webpack_public_path__ + "8db001836890e4ab18e00c87b1e506a9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/pretzel.png
// module id = 3039
// module chunks = 0